import React from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Dropdown,
  Header,
  Icon,
  Popup,
  Table,
} from "semantic-ui-react";
import { EmployeeManagerChangeModal } from "./EmployeeManagerChangeModal";
import { Icons } from "../../common/Icons";
import { EmployeePositionChangeModal } from "./EmployeePositionChangeModal";
import { EmployeeAreaChangeModal } from "./EmployeeAreaChangeModal";
import { LinkEmployee } from "../Routes";
import { LinkArea } from "../../areas/Routes";
import { LinkPosition } from "../../positions/Routes";
import { dateFmt, durationFmt } from "../../utils/date";
import { Divider } from "antd";
import { EmployeeManagerTerminateModal } from "./EmployeeManagerTerminateModal";
import { EmployeeManagerAccessModal } from "./EmployeeManagerAccessModal";
import { useAuth } from "../../utils/Auth";
import { useSettingValue } from "../../utils/Hooks";

export const EmployeeActions = ({ employee, reload, disableEdit = false }) => {
  const { user } = useAuth();
  const isNewEmployeeCreationScreenEnabled = useSettingValue(
    "T001_NEW_EMPLOYEE_CREATION_SCREEN_ENABLED",
  );
  const isEditEmployeeScreenEnabled = useSettingValue(
    "T005_EMPLOYEE_EDITING_SCREEN_ENABLED",
  );
  const history = useHistory();

  const manager = employee.current_manager?.manager;
  const area = employee.current_area?.area;
  const position = employee.current_position?.position;
  const availableActions = !!(
    employee._actions.change_area &&
    employee._actions.change_manager &&
    employee._actions.change_position
  );

  const isIntegrationAuthEnabled = useSettingValue("INTEGRATION_AUTH_ENABLED");
  const navigateToEditUser = () => {
    history.push(`funcionarios/edit_employee/${employee.id}`);
  };
  const actions = (
    <div>
      <Dropdown
        button
        labeled
        className="icon"
        icon="exchange"
        text="Alterar"
        disabled={!availableActions}
      >
        <Dropdown.Menu>
          {(user.active_employee
            ? user.active_employee._extra.is_superuser
            : user.is_superuser) && (
            <>
              <EmployeeManagerTerminateModal
                employee={employee}
                reload={reload}
              />
              <Divider style={{ backgroundColor: "#E0E1E2", margin: 0 }} />{" "}
            </>
          )}
          <EmployeeManagerChangeModal
            employee={employee}
            currentManager={manager}
            reload={reload}
            trigger={
              <Dropdown.Item text="Alterar gestor" icon={Icons.MANAGER} />
            }
          />
          <EmployeePositionChangeModal
            employee={employee}
            currentPosition={position}
            reload={reload}
            trigger={
              <Dropdown.Item text="Alterar cargo" icon={Icons.POSITION} />
            }
          />
          <EmployeeAreaChangeModal
            employee={employee}
            currentArea={area}
            reload={reload}
            trigger={<Dropdown.Item text="Alterar área" icon={Icons.AREA} />}
          />
          {isIntegrationAuthEnabled && (
            <EmployeeManagerAccessModal
              employee_id={employee.id}
              reload={reload}
            />
          )}
          {isEditEmployeeScreenEnabled && !disableEdit && (
            <Dropdown.Item
              text="Editar funcionário"
              icon="edit"
              onClick={navigateToEditUser}
            />
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );

  return (
    <Popup
      content={"Você pode alterar apenas a sua própria equipe!"}
      disabled={availableActions}
      mouseEnterDelay={200}
      position="top center"
      trigger={actions}
    />
  );
};

export const EmployeeInfo = ({ employee }) => {
  return (
    <Header style={{ marginBottom: 0.5 }}>
      <LinkEmployee employee={employee} />
      <Header.Subheader>
        {employee?.email || employee.employee_code}
      </Header.Subheader>
    </Header>
  );
};

export const EmployeeManager = ({ manager }) => {
  return (
    <>
      {manager ? manager.name : "-"}{" "}
      <LinkEmployee employee={manager}>
        <Icon name={"external"} />
      </LinkEmployee>
    </>
  );
};

export const EmployeePosition = ({ position }) => {
  return (
    <>
      {position ? position.name : "-"}{" "}
      <LinkPosition position={position}>
        <Icon name={"external"} />
      </LinkPosition>{" "}
    </>
  );
};

export const EmployeeArea = ({ area }) => {
  return (
    <>
      {area ? area.name : "-"}{" "}
      <LinkArea area={area}>
        <Icon name={"external"} />
      </LinkArea>{" "}
    </>
  );
};

export const EmployeeDuration = ({ employee }) => {
  const timespan = employee.current_manager?.timespan;
  if (!timespan) {
    return null;
  }
  return (
    <>
      {dateFmt(timespan.lower)} ({durationFmt(timespan.lower, timespan.upper)})
    </>
  );
};

export const EmployeeTableRow = ({ employee, reload }) => {
  let manager = employee.current_manager?.manager;
  let area = employee.current_area?.area;
  let position = employee.current_position?.position;

  return (
    <Table.Row>
      <Table.Cell>
        <EmployeeInfo employee={employee} />
      </Table.Cell>
      <Table.Cell>
        <EmployeeManager manager={manager} />
      </Table.Cell>
      <Table.Cell>
        <EmployeePosition position={position} />
      </Table.Cell>
      <Table.Cell>
        <EmployeeArea area={area} />
      </Table.Cell>
      <Table.Cell>
        <EmployeeActions employee={employee} reload={reload} />
      </Table.Cell>
    </Table.Row>
  );
};
